import { Dialog, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import { InternalUser } from "../../types/app";
import AllMatchingSalesRepsForm from "./AllMatchingSalesRepsForm";
import ChooseSalesRepsManuallyForm from "./ChooseSalesRepsManuallyForm";
import { defaultThreeRepsEntries } from "./helpers";

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (updatedSalesReps: InternalUser[]) => Promise<void>;
  isAllSalesRepsIdentical?: boolean;
  contactsReps?: InternalUser[];
  previousSalesReps?: InternalUser[];
};

const SalesRepComparisonModal = ({
  open,
  onClose,
  onSave,
  isAllSalesRepsIdentical = false,
  contactsReps = [],
  previousSalesReps = []
}: Props) => {
  const [salesReps, setSalesReps] = useState<(InternalUser | null)[]>(defaultThreeRepsEntries(previousSalesReps));
  const [marketingReps, setMarketingReps] = useState<(InternalUser | null)[]>(defaultThreeRepsEntries(contactsReps));

  const resetAndModalAndHandleClose = () => {
    setSalesReps([]);
    setMarketingReps([]);
    onClose();
  };

  const onSubmit = async (salesReps: (InternalUser | null)[]) => {
    const updatedSalesReps = salesReps.filter(Boolean) as InternalUser[];
    await onSave(updatedSalesReps);
    resetAndModalAndHandleClose;
  };

  useEffect(() => {}, []);

  return (
    <Dialog open={open} onClose={resetAndModalAndHandleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Sales Reps</DialogTitle>
      {isAllSalesRepsIdentical && (
        <AllMatchingSalesRepsForm
          onClose={onClose}
          salesReps={salesReps}
          setSalesReps={setSalesReps}
          marketingReps={marketingReps}
          setMarketingReps={setMarketingReps}
          onSubmit={onSubmit}
        />
      )}
      {!isAllSalesRepsIdentical && (
        <ChooseSalesRepsManuallyForm
          onClose={onClose}
          salesReps={previousSalesReps}
          marketingReps={marketingReps}
          onSubmit={onSubmit}
        />
      )}
    </Dialog>
  );
};

export default SalesRepComparisonModal;
